import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function OfferPrice() {
  return <section className="py-20 px-6 bg-white" data-id="element-147">
      <div className="max-w-2xl mx-auto text-center" data-id="element-148">
        <FadeIn data-id="element-149">
          <div className="bg-charcoal text-cream p-8 md:p-12 rounded-3xl shadow-2xl relative overflow-hidden" data-id="element-150">
            <div className="absolute top-0 left-0 w-full h-2 bg-terracotta" data-id="element-151"></div>
            <h2 className="font-serif text-3xl mb-4" data-id="element-152">Empieza tu Reset Hoy</h2>
            <p className="font-sans text-lg text-cream/80 mb-8 leading-relaxed" data-id="element-153">
              Recupera el control de tu cuerpo por menos de lo que cuesta una
              cena fuera. Olvida las suscripciones costosas a gimnasios que no
              te dan resultados.
            </p>
            <div className="mb-8" data-id="element-154">
              <span className="block text-sm uppercase tracking-wider text-cream/60 mb-2" data-id="element-155">
                Precio Especial de Lanzamiento
              </span>
              <span className="font-serif text-6xl font-bold text-white" data-id="element-156">
                $14.97{' '}
                <span className="text-2xl text-cream/60 font-sans font-normal" data-id="element-157">
                  USD
                </span>
              </span>
            </div>
            <Button href="https://www.plenavital.com/cart/48387544416481:1" className="w-full bg-terracotta text-white py-5 text-xl" data-id="element-158">
              QUIERO MI RESET METABÓLICO AHORA
            </Button>
          </div>
        </FadeIn>
      </div>
    </section>;
}